<app-nav-topnav></app-nav-topnav>
<main role="main">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</main>
